export const packages = [
  {
    _id: "f78sf8d",
    package: "free packages",
  },
  {
    _id: "df7d5fs2fr",
    package: "first packages 100 INR - 500 INR",
  },
  {
    _id: "df7fufer8f",
    package: "second packages 501 INR - 1000 INR",
  },
  {
    _id: "fdf7dsfdsf",
    package: "third packages 1001 INR - 2000 INR",
  },
  {
    _id: "df75fs5fd",
    package: "fourth packages 2001 INR - 5000 INR",
  },
  {
    _id: "dfs7fsfdf+5",
    package: "fifth packages 5001 INR more",
  },
];